import * as Sentry from '@sentry/react';
import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataImage } from './Image.proptypes';

import Picture from '../../../../ui/Atoms/Picture';

import { getStaticUrl } from '../../../utils/getStaticUrl';

import * as S from './Image.styles';

export const ImageSlice = ({ slice, documentType }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    image_slice_id: id,
    image_content: { alt, localFile } = {},
    image_title: imageTitle,
    image_caption: imageCaption,
  } = data || '';

  const imageProps = {
    imageObject: getImage(localFile),
    imageUrl: getStaticUrl(localFile?.publicURL),
    altText: alt,
    width: '100%',
  };

  if (!imageProps.imageUrl) {
    Sentry.captureMessage('Error: missing required data in Image slice');
    return null;
  }

  return (
    <S.ImageContainer documentType={documentType} id={id}>
      {imageTitle && <S.Title>{imageTitle}</S.Title>}
      <S.ImageWrapper>
        <Picture {...imageProps} />
        {imageCaption && <S.Caption>{imageCaption}</S.Caption>}
      </S.ImageWrapper>
    </S.ImageContainer>
  );
};

ImageSlice.propTypes = {
  /**
   * Current document type.
   */
  documentType: PropTypes.string,
  /**
   * Content of the Image slice.
   */
  slice: PropTypes.shape(propTypesDataImage),
};
